var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWideLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.653,
    height: 39.741
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wide_logo_svg__a",
    y1: 0.953,
    x2: 1.083,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01cce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0172f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1387"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 662",
    d: "M45.832 35.001h5.435l3.2-7.846h13.106l3.2 7.846h5.739L63.541 4.23h-4.734zm15.211-23.8l4.469 10.914h-8.986zm16.745 8.46c0 9.556 6.838 15.824 15.956 15.824a16.572 16.572 0 008.022-1.929l1.271 1.447h6.268l-3.77-4.383a15.677 15.677 0 004.207-10.961c0-9.556-6.882-15.824-16-15.824-9.423 0-15.955 6.926-15.955 15.824zm5.7 0c0-6.356 4.383-10.783 10.257-10.783 5.786 0 10.3 4.427 10.3 10.783a11.7 11.7 0 01-2.06 6.838l-2.718-3.2-3.507 3.156 2.586 3.025a11.073 11.073 0 01-4.6.964c-5.745-.002-10.26-4.648-10.26-10.785zm27.484 15.342h5.435l3.2-7.846h13.105l3.2 7.846h5.742L128.679 4.23h-4.734zm15.211-23.8l4.468 10.912h-8.986z",
    fill: "#021639"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 5",
    d: "M26.646 39.154c-12.5-4.048-24.852-6.033-26.244 0l-.371-2.587s-1.436-13.641 15.2-8.058 21.22 1.192 21.519-1.2c.143-1.152.7 2.478-.143 6.109-.738 3.163-2.543 6.327-6.623 6.326a10.889 10.889 0 01-3.338-.59zm0-13.545c-12.5-4.049-24.852-6.033-26.244 0l-.371-2.586s-1.436-13.641 15.2-8.058 21.22 1.192 21.519-1.2c.143-1.152.7 2.478-.143 6.109-.738 3.163-2.543 6.327-6.623 6.326a10.889 10.889 0 01-3.338-.59zm0-13.545C14.144 8.016 1.794 6.032.4 12.065L.031 9.478s-1.436-13.641 15.2-8.058S36.451 2.613 36.75.217c.143-1.152.7 2.478-.143 6.109-.738 3.163-2.543 6.326-6.623 6.326a10.891 10.891 0 01-3.338-.587z",
    fill: "url(#wide_logo_svg__a)"
  }))));
}
export default SvgWideLogo;